<template>
  <div class="error">
    <Alert />
    <strong>Uh-oh!</strong>
    <p>
      {{ message }}
      <br>
      {{ errorMessage }}
    </p>
    <br>
    <p>
      Please shoot us an email at
      <a href="mailto:support@appsumo.com">support@appsumo.com</a>
      for help.
    </p>
    <Button
      plain
      @click="$emit('close')"
    >
      Close
    </Button>
  </div>
</template>

<script>
// eslint-disable-next-line
import Alert from '../../../public/alert.svg?inline';
import Button from './Button.vue';

export default {
  name: 'Error',
  components: {
    Alert,
    Button,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    width: 100px;
    margin-bottom: 20px;
  }

  strong {
    font-weight: 700;
    font-size: 20px;
  }

  p {
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;

    a {
      text-decoration: none;
    }
  }
}
</style>
